import { useQuery } from "@tanstack/react-query";
import { Link as RouterLink } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { PageHeader } from "@/components/common/PageHeader";
import { QueryState } from "@/components/common/AsyncState";
import { fetchTeacherDashboard } from "@/api/dashboard";

export function TeacherDashboard() {
  const { data, isLoading, error } = useQuery({ queryKey: ["teacher-dashboard"], queryFn: fetchTeacherDashboard });

  return (
    <>
      <PageHeader title="Дашборд преподавателя" subtitle="Ваши занятия и группы" />
      <QueryState isLoading={isLoading} error={error}>
        {data && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 2.5, height: "100%" }}>
                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                  Занятия сегодня
                </Typography>
                <List dense>
                  {data.todayLessons.length === 0 && (
                    <Typography variant="body2" color="text.secondary">
                      Сегодня занятий нет.
                    </Typography>
                  )}
                  {data.todayLessons.map((lesson) => (
                    <ListItem
                      key={lesson.id}
                      disableGutters
                      secondaryAction={
                        <Button size="small" component={RouterLink} to="/journal">
                          Журнал
                        </Button>
                      }
                    >
                      <ListItemText
                        primary={`${lesson.timeSlot} · ${lesson.groupCode} · ${lesson.subjectName}`}
                        secondary={
                          <Chip
                            size="small"
                            sx={{ mt: 0.5 }}
                            label={lesson.marked ? "Отмечено" : "Не отмечено"}
                            color={lesson.marked ? "success" : "default"}
                          />
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 2.5, height: "100%" }}>
                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                  Мои группы
                </Typography>
                <List dense>
                  {data.groups.map((group) => (
                    <ListItem key={group.id} disableGutters>
                      <ListItemText
                        primary={`${group.code} · ${group.subjectName}`}
                        secondary={`${group.timeSlot} · ${group.studentsCount} учеников`}
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        )}
      </QueryState>
    </>
  );
}
